import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { SliderArrow } from '@/components/Icons/SliderArrow';
import styles from './FilesCarousel.module.scss';
export const SliderButton = ({ slideCondition, sliderAction, classNames, }) => slideCondition && (_jsx("div", { onClick: sliderAction, className: cn(styles.arrowButton, classNames), tabIndex: 0, role: "button", onKeyDown: sliderAction, children: _jsx(SliderArrow, {}) }));
